module.exports = __webpack_public_path__ + "media/images/icons/flags/ID-24138bfe50ef67f1bbff6366d8d9fa3c.svg";